import ready from '../components/_ready';
import activeVirtualKeyboard from '../components/_keyboard';
import encryptValue from '../global/encrypt';

ready(() => {
  const keyboardIcon = document.getElementById('keyboard-icon');
  if (keyboardIcon) {
    keyboardIcon.addEventListener('click', () => {
      const keyboard = document.querySelector('.simple-keyboard');

      if (!keyboard.innerHTML) {
        activeVirtualKeyboard();
      } else {
        const keyboardInvisible = keyboard.hidden;
        if (keyboardInvisible) {
          keyboard.style.display = 'block';
          keyboard.hidden = false;
        } else {
          keyboard.style.display = 'none';
          keyboard.hidden = true;
        }
      }
    });
  }

  const loginForm = document.querySelector('#js--login-form');

  if (loginForm) {
    loginForm.addEventListener('submit', (event) => {
      event.stopPropagation();
      const passwordInput = document.getElementById('password');
      const passwordEInput = document.querySelector('input[name="pass"]');
      const password = passwordInput.value;
      passwordInput.setAttribute('disabled', 'disabled');

      const pEncrypt = encryptValue(password);

      passwordEInput.value = pEncrypt;

      const userInput = document.getElementById('username');
      const userEInput = document.querySelector('input[name="user"]');
      const username = userInput.value;
      userInput.setAttribute('disabled', 'disabled');

      const uEncrypt = encryptValue(username);

      userEInput.value = uEncrypt;
    });
  }
});
